
import arrayMixin from './arrayMixin';
import { crmFileDeleteAPI } from '@/api/common';
import { fileSize } from '@/utils/index';

export default {
  name: 'XhFiles', // 新建 file  以数组的形式上传
  components: {},
  filters: {
    fileName: function fileName(file) {
      var name = file.name && file.name.length > 10 ? file.name.substring(0, 10) + '...' : file.name;
      return name + '(' + fileSize(file.size) + ')';
    }
  },
  mixins: [arrayMixin],
  props: {},
  data: function data() {
    return {
      batchId: '' // 批次ID
    };
  },

  computed: {},
  watch: {
    dataValue: {
      handler: function handler() {
        if (!this.batchId && this.dataValue && this.dataValue.length) {
          this.batchId = this.dataValue[0].batchId;
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    selectImage: function selectImage() {
      var _this = this;

      if (!this.disabled) {
        this.$wkFile.select().then(function (ev) {
          _this.xhUploadFile(ev);
        });
      }
    },


    /**
     * 图片选择出发
     */
    xhUploadFile: function xhUploadFile(event) {
      var _this2 = this;

      var files = event.target.files;
      var firstFile = files[0];
      this.sendFileRequest(firstFile, function () {
        for (var index = 1; index < files.length; index++) {
          var file = files[index];
          _this2.sendFileRequest(file);
        }
        event.target.value = '';
      });
    },

    // 发送请求
    sendFileRequest: function sendFileRequest(file, result) {
      var _this3 = this;

      this.$wkUploadFile.upload({
        file: file,
        params: {
          batchId: this.batchId,
          type: 'file'
        }
      }).then(function (_ref) {
        var res = _ref.res;

        var data = res.data || {};
        if (_this3.batchId == '') {
          _this3.batchId = data.batchId;
        }
        data.size = fileSize(data.size);
        _this3.dataValue.push(data);
        _this3.$emit('value-change', {
          index: _this3.index,
          value: _this3.dataValue
        });
        if (result) {
          result();
        }
      }).catch(function () {});
    },

    /** 删除图片 */
    deleteFile: function deleteFile(item, index) {
      var _this4 = this;

      this.$confirm('您确定要删除该文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        crmFileDeleteAPI({
          id: item.file_id,
          module: '',
          save_name: item.save_name
        }).then(function (res) {
          _this4.dataValue.splice(index, 1);
          _this4.$emit('value-change', {
            index: _this4.index,
            value: _this4.dataValue
          });
          _this4.$message.success('操作成功');
        }).catch(function () {});
      }).catch(function () {});
    }
  }
};